module.exports = __webpack_public_path__ + "static/classe-d616719d72666c60ad84b104e13a63f6.png";